// module dependencies
import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from 'react-redux';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import createSagaMiddleware from 'redux-saga';
import {configureStore} from '@reduxjs/toolkit';
import {ThemeProvider, createTheme} from '@mui/material';

import reportWebVitals from './reportWebVitals';
import rootReducer from './store';
import rootSaga from './store/sagas';
import './i18n';


// styles
import './index.scss';
import router from './routes';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    //@ts-expect-error
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>  getDefaultMiddleware({thunk: false, serializableCheck: false}).concat(sagaMiddleware),
})

sagaMiddleware.run(rootSaga);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
const theme = createTheme({
  palette: {
    primary: {
      main: '#0d1f2d',
      dark: '#04080f',
      light: '#334139',
      contrastText: '#fff',
    },
    secondary: {
      main: '#9ac1bc',
      dark: '#476c9b',
      light: '#507dbc',
      contrastText: '#000',
    },
    error: {
      main: '#ed695a',
    },
    success: {
      main: '#18d85d',
    }
  }
});

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <Suspense fallback={<h1>Loading</h1>}>
        <Provider store={store}>
            <RouterProvider router={router} />
        </Provider>
      </Suspense>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
